import * as GeneralRepository from "./general-repository";
import * as SolicitudProvider from "../providers/solicitud-provider";

export const obtenerSolicitudes = async (idSolicitudMultiple) => {
    const response = await SolicitudProvider.obtenerSolicitudes(idSolicitudMultiple)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            solicitudes: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerSolicitudes(idSolicitudMultiple)
            } else {
                return {
                    error: response.auditResponse,
                    solicitudes: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                solicitudes: null
            }
        }
    }
}

export const actualizarSolicitud = async (idSolicitudMultiple, marcaLpdp, marcaAdicionalLpdp, solicitud) => {
    const response = await SolicitudProvider.actualizarSolicitud(idSolicitudMultiple, {
        marcaLpdp: marcaLpdp,
        marcaAdicionalLpdp: marcaAdicionalLpdp,
        solicitud: solicitud
    })
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            solicitud: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await actualizarSolicitud(idSolicitudMultiple, marcaLpdp, marcaAdicionalLpdp, solicitud)
            } else {
                return {
                    error: response.auditResponse,
                    solicitud: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                solicitud: null
            }
        }
    }
}

export const obtenerPolizas = async (tipoDocumento, numeroDocumento, tipo) => {
    const response = await SolicitudProvider.obtenerPolizas(tipoDocumento, numeroDocumento, tipo)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            polizas: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerPolizas(tipoDocumento, numeroDocumento, tipo)
            } else {
                return {
                    error: response.auditResponse,
                    polizas: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                polizas: null
            }
        }
    }
}

export const guardarReemplazoTraspaso = async (idSolicitud, request) => {
    const response = await SolicitudProvider.guardarReemplazoTraspaso(idSolicitud, request)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            reemplazo: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await guardarReemplazoTraspaso(idSolicitud, request)
            } else {
                return {
                    error: response.auditResponse,
                    reemplazo: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                reemplazo: null
            }
        }
    }
}